import { useEffect, useState } from "react";
import { apiCall } from "../../../../_services/apiCall";
import config from "../../../../config/config";
/**
 * Financial years the migrated old-DB answers live under. getFinancialYear
 * only returns the company's current years (31 / 2025-2026), so these are
 * offered statically; a backend entry with the same id wins on merge.
 */
const STATIC_FINANCIAL_YEARS = [
    // { id: 6, financial_year_value: "2023-2024" },
    // { id: 30, financial_year_value: "2024-2025" },
];

/**
 * Lightweight metadata hook for the Qualitative page.
 * Fetches only the filter dropdowns (financial years, frameworks, locations)
 * without triggering the quantitative-specific getReportingQuestionnew endpoint.
 */
export const useQualitativeMeta = () => {
    const [financialYears, setFinancialYears] = useState([]);
    const [frameworks, setFrameworks] = useState([]);
    const [locations, setLocations] = useState([]);
    const [modules, setModules] = useState([]);
    const [metaLoading, setMetaLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;

        const fetchMeta = async () => {
            try {
                const [fyRes, srcRes, fwRes] = await Promise.all([
                    apiCall(`${config.POSTLOGIN_API_URL_COMPANY}getFinancialYear`, {}, {}, "GET"),
                    apiCall(`${config.POSTLOGIN_API_URL_COMPANY}getSource`, {}, {}, "GET"),
                    apiCall(`${config.POSTLOGIN_API_URL_COMPANY}getFramework`, {}, { type: "ALL" }, "GET"),
                ]);

                if (cancelled) return;

                if (fyRes.isSuccess) {
                    const fetched = fyRes.data?.data || [];
                    const fetchedIds = new Set(fetched.map((fy) => fy.id));
                    setFinancialYears([
                        ...STATIC_FINANCIAL_YEARS.filter((fy) => !fetchedIds.has(fy.id)),
                        ...fetched,
                    ]);
                }
                if (srcRes.isSuccess) {
                    setLocations(
                        (srcRes.data?.data || []).map((l) => ({
                            id: String(l.id),
                            name:
                                l.unitCode ||
                                `${l.location?.area} ${l.location?.city} ${l.location?.state} ${l.location?.country} ${l.location?.zipCode}`,
                            location: l,
                        }))
                    );
                }
                if (fwRes.isSuccess) setFrameworks(fwRes.data?.data || []);
            } catch (err) {
                console.error("Error fetching qualitative metadata:", err);
            } finally {
                if (!cancelled) setMetaLoading(false);
            }
        };

        fetchMeta();
        return () => { cancelled = true; };
    }, []);

    return { financialYears, frameworks, locations, modules, metaLoading };
};
